module.exports = __webpack_public_path__ + "static/media/ProfAshishDubey.4f3d92e7.png";